var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-wrapper',[_c('statement-komisi',{attrs:{"office-id":_vm.me.office_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }